import { IconComponent } from '../icon.types';

export const PhoneIcon: IconComponent = (props) => (
  <svg
    width="36"
    height="36"
    viewBox="0 0 36 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M6 0V31.5C6 33.981 8.019 36 10.5 36H25.5C27.981 36 30 33.981 30 31.5V0H6ZM21 31.5H15V28.5H21V31.5Z"
      fill="currentColor"
    />
  </svg>
);
